import { Property } from '../../../types';
import { HealthIssue } from '../../../types/inventoryHealth';
import { isApartmentOrStudio } from './adminFeeRule';

export function checkFloorNumberRule(property: Property): HealthIssue | null {
  if (!isApartmentOrStudio(property.tipoinmueble)) {
    return null;
  }

  const rawPiso = property.piso;
  const isMissing =
    rawPiso === null ||
    rawPiso === undefined ||
    String(rawPiso).trim() === '' ||
    String(rawPiso).trim().toLowerCase() === 'null' ||
    String(rawPiso).trim().toLowerCase() === 'undefined';

  if (isMissing) {
    return {
      ruleId: 'floor_number',
      ruleName: 'Falta Número de Piso',
      severity: 'critical',
      message: 'Propiedad en propiedad horizontal (apto/apartaestudio) sin número de piso especificado.',
      field: 'piso',
      currentValue: rawPiso,
      suggestedFix: 'Indicar el número de piso en el que se encuentra la unidad (ej. 3, 5, PB).',
    };
  }

  return null;
}
